import axios from "../httpHandler";

export const getPermissions = async (filters) => {
  try {
    const result = await axios.get(`user/permission${filters ?? ''}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getUsers = async (pageOffset = 1) => {
  try {
    let filters = '';
    if (pageOffset > 1) {
      filters += `?page=${pageOffset}&`;
    }

    const result = await axios.get(`user${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createUser = async (data) => {
  return axios.post(`user`, {
    ...data,
  });
};

export const updateUser = (data) => {
  return axios.patch(`user/${data?.id}`, {
    ...data,
  });
};

export const deleteUser = async ({ id }) => {
  return axios.delete(`user/${id}`);
};

export const getUserGroups = async (filters) => {
  try {
    const result = await axios.get(`user/group${filters ?? ''}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createUserGroup = async (data) => {
  return axios.post(`user/group`, {
    ...data,
  });
};

export const updateUserGroup = (data) => {
  return axios.put(`user/group/${data?.id}`, {
    ...data,
  });
};

export const deleteUserGroup = async ({ id }) => {
  return axios.delete(`user/group/${id}`);
};